import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { DomainService } from '../../domain.service';
import { AlertsService } from '../../core/alerts.service';
import { LookupInput } from '../../base/inputs/input-lookup/input-lookup';
import { LocalisationService } from '../../core/localisation.service';
/**
 * Class for assignee component.
 */
var InputAssigneeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputAssigneeComponent, _super);
    /**
     * Constructs an InputAssigneeComponent
     * @param element Reference to HTML document element
     * @param domainService The domain service
     */
    function InputAssigneeComponent(domainService, alertsService, translateService, localisationService) {
        return _super.call(this, domainService, alertsService, translateService, localisationService) || this;
    }
    return InputAssigneeComponent;
}(LookupInput));
export { InputAssigneeComponent };
